import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { GlobalEffects } from './store/global.effects';
import * as fromGlobal from './store/global.reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    provideState(fromGlobal.globalFeatureKey, fromGlobal.reducer),
    provideEffects(GlobalEffects),
  ],
})
export class GlobalStoreModule {}
